'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LS_ACCESS_TOKEN_KEY = exports.LS_ACCESS_TOKEN_KEY = 'gitment-comments-token';
var LS_USER_KEY = exports.LS_USER_KEY = 'gitment-user-info';

var NOT_INITIALIZED_ERROR = exports.NOT_INITIALIZED_ERROR = new Error('Comments Not Initialized');
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/gitment/dist/constants.js
// module id = 0
// module chunks = 0